import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Select, MenuItem, FormControl, InputLabel,
    Grid, Typography, Box, Radio, RadioGroup, FormControlLabel,
    Divider,
    TextField
} from '@mui/material';
import dayjs from 'dayjs';
import api_service from '../../network/api_callbacks';
import { generatePublicUrlForFileInAWSS3Bucket } from '../../services/uploadFileOnAWS_S3_Bucket';
import { GameCssStyles } from '../GameManagement/GameCssStyles';
import { set } from 'react-hook-form';
import { toast } from 'react-toastify';

const movie = {
    collection: 0,
}

const song = {
    count: 0,
    pos: 0,
}

const video = {
    view: 0,
}

const reel = {
    view: 0,
    comment: 0,
    share: 0,
}

const influencers = {
    follower: 0,
    upload: 0,
    view: 0,
}

const categoryWiseStats = {
    movie: movie,
    song: song,
    video: video,
    reel: reel,
    influencers: influencers,
}

export default function SubmitStatsDialog({ open, onClose, selectedEntityGroup }) {

    const [statsList, setStatsList] = useState([]);
    const [inputValues, setInputValues] = useState({});

    const CheckAndShowKeys = Object.freeze({
        Collection: "collection",
        Points: "points",
        Count: "count",
        Pos: "pos",
        View: "view",
        Comment: "comment",
        Share: "share",
        Follower: "follower",
        Upload: "upload",
    });

    useEffect(() => {
        if (statsList?.length === 0 && selectedEntityGroup?.stats?.length > 0) {
            setStatsList(selectedEntityGroup?.stats || []);
        }
        return () => {
            setStatsList([]);
            setInputValues({});
        };
    }, [selectedEntityGroup]);

    // Handle input changes
    const handleInputChange = (option, entId, key, value) => {
        setInputValues((prev) => ({
            ...prev,
            [entId]: {
                ...prev[entId],
                entityId: entId,
                category: selectedEntityGroup?.typeKey,
                [key]: value,
            }
        }));
        console.log("Input Values : ", inputValues);
    };

    const submitFLRealStats = async () => {
        try {
            const data = Object.values(inputValues);
            const request = { entities: data }
            console.log('📘 submitFLRealStats Request:', request);
            const response = await api_service.submitStats(request);
            console.log('📘 submitFLRealStats Response:', response?.status)
            const status = response?.status;
            const resData = response?.data;
            if (status === 200) {
                toast.success("Stats submitted successfully");
            }
        } catch (error) {
            console.error('❌ Failed to fetch submitFLRealStats:', error);
        }
    }

    const currentFields = categoryWiseStats[selectedEntityGroup?.typeKey] || {};

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle> {selectedEntityGroup?.typeKey.charAt(0).toUpperCase() + selectedEntityGroup?.typeKey.slice(1)}</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ p: 0 }}>
                    {statsList?.length > 0 && (
                        statsList?.map((option, idx) => {
                            return (
                                <Grid item key={option?.entId || idx}>
                                    <Box
                                        sx={{
                                            position: "relative",
                                            height: 140,
                                            width: "100%",
                                            borderRadius: 2,
                                            overflow: "hidden",
                                            backgroundColor: "whitesmoke",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 1,
                                            mb: 2,
                                            border: "1px solid #ccc",
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                width: 80,
                                                height: 80,
                                                borderRadius: 2,
                                                overflow: "hidden",
                                                backgroundImage: `url(${generatePublicUrlForFileInAWSS3Bucket(option?.entityDetail?.image) || ""})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                mr: 2,
                                                flexShrink: 0,
                                            }}
                                        />

                                        <Box sx={{ flexGrow: 1 }}>
                                            <Typography fontWeight="bold" sx={{ fontSize: 12 }}>
                                                {option?.entityDetail?.displayName}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {option?.entityDetail?.type}
                                            </Typography>
                                        </Box>


                                        <Grid container spacing={2}>
                                            {Object.keys(currentFields).map((key) => (
                                                <Grid item xs={6} key={key}>
                                                    <TextField
                                                        fullWidth
                                                        label={key}
                                                        type="number"
                                                        value={inputValues[option?.entId]?.[key] ?? 0}
                                                        onChange={(e) =>
                                                            handleInputChange(option, option?.entId, key, e.target.value)
                                                        }
                                                        sx={{ ...GameCssStyles.formSingleLineTextField_sx, width: '150px' }}
                                                    />
                                                </Grid>
                                            ))}
                                        </Grid>

                                    </Box>
                                </Grid>
                            )
                        }))}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => {
                    setStatsList([]);
                    setInputValues({});
                    onClose();
                }} variant="contained">Close</Button>
                <Button onClick={() => {
                    setStatsList([]);
                    setInputValues({});
                    submitFLRealStats();
                    onClose();
                }} variant="contained">Submit</Button>
            </DialogActions>
        </Dialog>
    );
}
